import { handleResponse, handleError, getBaseUrlPortal } from "./apiUtils";
import { store } from "../redux/configureStore"; // adjust path as needed
//const baseUrl = process.env.API_URL + "/clubs/";
const baseUrl = getBaseUrlPortal(); //"https://localhost:44354/api/";

async function handleDatiScuolaResponse(response) {
  if (response.ok) return response.json();

  console.log("RESPONSE NOT OK", response);
  alert(
    "Errore nel caricamento dei dati della scuola. Verifica la connessione a internet. 3"
  );
  window.location.href = "/";
}

export function getDatiScuola(idScuola, lang) {
  console.log("LOADING SCHOOL DATA");

  return fetch(`${baseUrl}scuole/${idScuola}?lang=${lang}`, {
    headers: {
      "X-SK-ApiKey": "ca89dd70-63cb-4e8e-af44-bc22062563cf", // Replace with your actual API key
    },
  })
    .then(handleDatiScuolaResponse)
    .catch(handleError);
}
